export default __webpack_public_path__ + "static/media/e-ks-picturemark-l.323b7f96.svg";